import React from "react";
import styled, { css } from "styled-components";
import { Col, Row } from "components/bootstrap";
import { Icon } from "components/common";
import useUserDateTime from "hooks/useUserDateTime";
import AbsoluteCalendarInput from "data-lake/components/AbsoluteCalendarInput";
const Timezone = styled.p(
  ({ theme }) => css`
    font-size: ${theme.fonts.size.small};
    padding-left: ${theme.spacings.xs};
    margin: 0;
    min-height: 34px;
    display: flex;
    align-items: center;
  `
);
const AbsoluteWrapper = styled.div`
  display: flex;
  align-items: stretch;
  justify-content: space-around;
`;
const RangeWrapper = styled.div`
  flex: 4;
  align-items: center;
  display: flex;
  flex-direction: column;

  .DayPicker-wrapper {
    padding-bottom: 0;
  }
`;
const IconWrap = styled.div`
  flex: 0.75;
  display: flex;
  align-items: center;
  justify-content: center;
  transform: translateY(-0.65em);
`;
const TimeRangeSelectInput = ({
  timerange = {
    type: "absolute",
    from: (/* @__PURE__ */ new Date()).toString(),
    to: (/* @__PURE__ */ new Date()).toString()
  },
  disableTimeMinute = false,
  disableTimeSecond = false
}) => {
  const { userTimezone } = useUserDateTime();
  return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement(AbsoluteWrapper, null, /* @__PURE__ */ React.createElement(RangeWrapper, null, /* @__PURE__ */ React.createElement(
    AbsoluteCalendarInput,
    {
      nextTimeRange: timerange,
      range: "from",
      disableTimeMinute,
      disableTimeSecond
    }
  )), /* @__PURE__ */ React.createElement(IconWrap, null, /* @__PURE__ */ React.createElement(Icon, { name: "arrow_right_alt" })), /* @__PURE__ */ React.createElement(RangeWrapper, null, /* @__PURE__ */ React.createElement(
    AbsoluteCalendarInput,
    {
      nextTimeRange: timerange,
      range: "to",
      disableTimeMinute,
      disableTimeSecond: disableTimeMinute
    }
  ))))), /* @__PURE__ */ React.createElement(Row, { className: "row-sm" }, /* @__PURE__ */ React.createElement(Col, { md: 6 }, /* @__PURE__ */ React.createElement(Timezone, null, "All timezones using: ", /* @__PURE__ */ React.createElement("b", null, userTimezone)))));
};
export default TimeRangeSelectInput;
